import React, { ReactNode } from 'react';
import styles from './index.module.scss';

interface CenteredLayoutProps {
  children: ReactNode;
}

function CenteredLayout({ children }: CenteredLayoutProps) {
  return (
    <div className={styles.root}>
      <div>
        <div className={styles.card}>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default CenteredLayout;
